// extracted by css-extract-rspack-plugin
export default {"tooltipTitle":"tooltipTitle-u0yxnI","tooltipRow":"tooltipRow-fULcwi","tooltipLabel":"tooltipLabel-bYER3c","tooltipColor":"tooltipColor-d6nGAn","tooltipValue":"tooltipValue-RR8lwr"};